import { loginDetails } from "../actionTypes"

export const loginDetail = (data)=>{
    return {
        type:loginDetails.LOGINUSER,
        payload:data
    }
}